import React, { Component } from 'react';
//import Utilities from '../../global/Utilities';

class ViewOfflineImage extends Component {

    // loadImage(image) {
    //     const byteArray = Utilities.arrayBufferToBase64(image);
    //     return `data:image/jpg;base64, ${byteArray}`;
    // }

    render() {
        const { image } = this.props;
        return (
            <div className="col-4 image-info" >
                <div className="img-placeholder">
                    <img src={image} alt="" />
                </div>
            </div>
        )
    }
}

export default ViewOfflineImage;
